// removed by extract-text-webpack-plugin
module.exports = {"Github":"src-components-Misc-Github----Github-module---Github---3IQiU","Head":"src-components-Misc-Github----Github-module---Head---pK-D_","Loading":"src-components-Misc-Github----Github-module---Loading---23uDv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Misc/Github/Github.module.css
// module id = 353
// module chunks = 35783957827783